var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import PersistenceManager from "../functions/persistence";
import client from "../http/client";
var AuthContext = createContext(undefined);
var isGuestUser = function (isGuest) {
    if (typeof isGuest === "boolean") {
        return isGuest;
    }
    if (typeof isGuest === "number") {
        return isGuest === 1;
    }
    if (typeof isGuest === "string") {
        var normalizedIsGuest = isGuest.trim().toLowerCase();
        return normalizedIsGuest === "1" || normalizedIsGuest === "true";
    }
    return false;
};
var getApiErrorMessage = function (error) {
    var _a, _b;
    if (!error || typeof error !== "object") {
        return null;
    }
    var response = error.response;
    var data = response === null || response === void 0 ? void 0 : response.data;
    var friendlyName = String(((_a = data === null || data === void 0 ? void 0 : data.friendly) === null || _a === void 0 ? void 0 : _a.name) || (data === null || data === void 0 ? void 0 : data.name) || "").trim();
    var friendlyDescription = String(((_b = data === null || data === void 0 ? void 0 : data.friendly) === null || _b === void 0 ? void 0 : _b.description) || (data === null || data === void 0 ? void 0 : data.description) || "").trim();
    if (friendlyName && friendlyDescription) {
        return "".concat(friendlyName, " ").concat(friendlyDescription).trim();
    }
    if (friendlyDescription) {
        return friendlyDescription;
    }
    if (friendlyName) {
        return friendlyName;
    }
    var message = String((data === null || data === void 0 ? void 0 : data.message) || "").trim();
    return message || null;
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isAuthenticated = _b[0], setIsAuthenticated = _b[1];
    var _c = useState(false), hasResolvedAuthState = _c[0], setHasResolvedAuthState = _c[1];
    var _d = useState(null), user = _d[0], setUser = _d[1];
    var _e = useState(null), history = _e[0], setHistory = _e[1];
    var updateUserProfile = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var url, response, nextUser, _error_1;
        var firstName = _b.firstName, lastName = _b.lastName, email = _b.email, phone = _b.phone;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = "/user/profile";
                    if (!(user === null || user === void 0 ? void 0 : user.id)) {
                        return [2 /*return*/, false];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post(url, {
                            user_id: user.id,
                            first_name: firstName,
                            last_name: lastName,
                            email: email,
                            phone: phone !== null && phone !== void 0 ? phone : "",
                        })];
                case 2:
                    response = _c.sent();
                    if (response.status === 200) {
                        nextUser = __assign(__assign({}, user), { first_name: firstName, last_name: lastName, email: email, phone: phone });
                        setUser(nextUser);
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _error_1 = _c.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/, false];
            }
        });
    }); }, [user]);
    var deleteUserAccount = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var url, pendingToastStorageKey, accountDeletedToast, response, serializedToast, didPersistToast, _error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/user/destroy/api";
                    pendingToastStorageKey = "ui-pending-toast";
                    accountDeletedToast = {
                        message: "Your account has been successfully deleted. We're sorry to see you go.",
                        variant: "success",
                        mustAcknowledge: false,
                    };
                    if (!(user === null || user === void 0 ? void 0 : user.id)) {
                        return [2 /*return*/, false];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post(url, {
                            user_id: user.id,
                            store_id: user.store_id,
                        })];
                case 2:
                    response = _a.sent();
                    if (response.status === 200) {
                        serializedToast = JSON.stringify(accountDeletedToast);
                        window.sessionStorage.setItem(pendingToastStorageKey, serializedToast);
                        didPersistToast = window.sessionStorage.getItem(pendingToastStorageKey) === serializedToast;
                        if (!didPersistToast) {
                            return [2 /*return*/, false];
                        }
                        window.location.href = "".concat(window.relativeURI(), "/logout");
                        return [2 /*return*/, true];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _error_2 = _a.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/, false];
            }
        });
    }); }, [user]);
    var setAuthStateFromUser = useCallback(function (userData) {
        var authenticated = Boolean(userData) && !isGuestUser(userData === null || userData === void 0 ? void 0 : userData.is_guest);
        setUser(userData);
        setIsAuthenticated(authenticated);
    }, []);
    var extractUserFromResponse = useCallback(function (responseData) {
        var _a;
        if (!responseData || Object.keys(responseData).length === 0) {
            return null;
        }
        if ("user" in responseData) {
            return (_a = responseData.user) !== null && _a !== void 0 ? _a : null;
        }
        return responseData;
    }, []);
    var normalizeHistoryData = useCallback(function (historyData) {
        var _a, _b;
        return {
            offers: Array.isArray(historyData.offers) ? historyData.offers : [],
            orders: Array.isArray(historyData.orders) ? historyData.orders : [],
            addresses: Array.isArray(historyData.addresses) ? historyData.addresses : [],
            saved_cards: Array.isArray(historyData.saved_cards) ? historyData.saved_cards : [],
            current_points: (_a = historyData.current_points) !== null && _a !== void 0 ? _a : null,
            points_to_next: (_b = historyData.points_to_next) !== null && _b !== void 0 ? _b : null,
        };
    }, []);
    var checkForUserHistoryData = useCallback(function (userIdOverride) { return __awaiter(void 0, void 0, void 0, function () {
        var resolvedUserId, response, normalizedHistory, _error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resolvedUserId = userIdOverride !== null && userIdOverride !== void 0 ? userIdOverride : user === null || user === void 0 ? void 0 : user.id;
                    if (!resolvedUserId) {
                        setHistory(null);
                        return [2 /*return*/, null];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.post("/user/history/api", { user_id: Number(resolvedUserId) })];
                case 2:
                    response = _a.sent();
                    normalizedHistory = normalizeHistoryData(response.data);
                    setHistory(normalizedHistory);
                    return [2 /*return*/, normalizedHistory];
                case 3:
                    _error_3 = _a.sent();
                    setHistory(null);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [normalizeHistoryData, user === null || user === void 0 ? void 0 : user.id]);
    var checkForUserData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, parsedUser, _error_4, _error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 8, 9, 10]);
                    return [4 /*yield*/, client.get("/user/api")];
                case 1:
                    response = _a.sent();
                    parsedUser = extractUserFromResponse(response.data);
                    setAuthStateFromUser(parsedUser);
                    if (!((parsedUser === null || parsedUser === void 0 ? void 0 : parsedUser.id) && !isGuestUser(parsedUser.is_guest))) return [3 /*break*/, 6];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, checkForUserHistoryData(parsedUser.id)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _error_4 = _a.sent();
                    setHistory(null);
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setHistory(null);
                    _a.label = 7;
                case 7: return [2 /*return*/, parsedUser];
                case 8:
                    _error_5 = _a.sent();
                    setAuthStateFromUser(null);
                    setHistory(null);
                    return [2 /*return*/, null];
                case 9:
                    setHasResolvedAuthState(true);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [checkForUserHistoryData, extractUserFromResponse, setAuthStateFromUser]);
    var handleLogin = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var response;
        var _c;
        var email = _b.email, password = _b.password, rememberMe = _b.rememberMe, checkoutAddressId = _b.checkoutAddressId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, client.post("/login/api", {
                        email: email,
                        password: password,
                        remember_me: rememberMe,
                        checkout_address_id: checkoutAddressId !== null && checkoutAddressId !== void 0 ? checkoutAddressId : null,
                    })];
                case 1:
                    response = _d.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 3];
                    PersistenceManager.setUserRewardsInfo((_c = response.data) === null || _c === void 0 ? void 0 : _c.rewards_info);
                    return [4 /*yield*/, checkForUserData()];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3: return [2 /*return*/, response.data];
            }
        });
    }); }, [checkForUserData]);
    var createUser = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var response, parsedUser, checkoutAddress, error_1;
        var firstName = _b.firstName, lastName = _b.lastName, email = _b.email, phone = _b.phone, _c = _b.password, password = _c === void 0 ? "" : _c, _d = _b.isGuest, isGuest = _d === void 0 ? false : _d, _e = _b.useRewards, useRewards = _e === void 0 ? false : _e, _f = _b.checkoutAddressId, checkoutAddressId = _f === void 0 ? null : _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, client.post("/user/create/api", {
                            is_guest: isGuest,
                            first_name: firstName,
                            last_name: lastName,
                            email: email,
                            password: password,
                            phone: phone,
                            use_rewards: useRewards,
                            checkout_address_id: checkoutAddressId,
                        })];
                case 1:
                    response = _g.sent();
                    parsedUser = extractUserFromResponse(response.data);
                    checkoutAddress = "checkout_address" in response.data
                        ? response.data.checkout_address
                        : null;
                    setAuthStateFromUser(parsedUser);
                    if (!((parsedUser === null || parsedUser === void 0 ? void 0 : parsedUser.id) && !isGuestUser(parsedUser.is_guest))) return [3 /*break*/, 3];
                    return [4 /*yield*/, checkForUserHistoryData(parsedUser.id)];
                case 2:
                    _g.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setHistory(null);
                    _g.label = 4;
                case 4: return [2 /*return*/, {
                        user: parsedUser,
                        checkoutAddress: checkoutAddress,
                        errorMessage: null,
                    }];
                case 5:
                    error_1 = _g.sent();
                    return [2 /*return*/, {
                            user: null,
                            checkoutAddress: null,
                            errorMessage: getApiErrorMessage(error_1),
                        }];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [checkForUserHistoryData, extractUserFromResponse, setAuthStateFromUser]);
    var refreshUserHistory = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!(user === null || user === void 0 ? void 0 : user.id)) {
                return [2 /*return*/, null];
            }
            return [2 /*return*/, checkForUserHistoryData(user.id)];
        });
    }); }, [checkForUserHistoryData, user === null || user === void 0 ? void 0 : user.id]);
    var createAddress = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var resolvedUserId, response, _error_6;
        var _c;
        var address = _b.address, address2 = _b.address2, city = _b.city, state = _b.state, zip = _b.zip, userId = _b.userId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    resolvedUserId = userId !== null && userId !== void 0 ? userId : user === null || user === void 0 ? void 0 : user.id;
                    if (!resolvedUserId) {
                        return [2 /*return*/, null];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, client.post("/user/addresses/create/api", {
                            address: address,
                            address2: address2,
                            city: city,
                            state: state,
                            zip: zip,
                            user_id: resolvedUserId,
                        })];
                case 2:
                    response = _d.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, checkForUserHistoryData(resolvedUserId)];
                case 3:
                    _d.sent();
                    return [2 /*return*/, (_c = response.data) !== null && _c !== void 0 ? _c : null];
                case 4: return [3 /*break*/, 6];
                case 5:
                    _error_6 = _d.sent();
                    return [2 /*return*/, null];
                case 6: return [2 /*return*/, null];
            }
        });
    }); }, [checkForUserHistoryData, user === null || user === void 0 ? void 0 : user.id]);
    var updateAddress = useCallback(function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var url, response, _error_7;
        var addressId = _b.addressId, address = _b.address, address2 = _b.address2, city = _b.city, state = _b.state, zip = _b.zip, isDefault = _b.isDefault;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    url = "/user/addresses/update/api";
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, client.post(url, __assign({ address_id: addressId, address: address, address2: address2, city: city, state: state, zip: zip }, (typeof isDefault === "boolean" ? { is_default: isDefault } : {})))];
                case 2:
                    response = _c.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, refreshUserHistory()];
                case 3:
                    _c.sent();
                    return [2 /*return*/, true];
                case 4: return [3 /*break*/, 6];
                case 5:
                    _error_7 = _c.sent();
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/, false];
            }
        });
    }); }, [refreshUserHistory]);
    var deleteAddress = useCallback(function (addressId) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, _error_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/user/addresses/destroy/api";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, client.post(url, {
                            address_id: addressId,
                        })];
                case 2:
                    response = _a.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, refreshUserHistory()];
                case 3:
                    _a.sent();
                    return [2 /*return*/, true];
                case 4: return [3 /*break*/, 6];
                case 5:
                    _error_8 = _a.sent();
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/, false];
            }
        });
    }); }, [refreshUserHistory]);
    var deleteSavedCard = useCallback(function (cardId) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, _error_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "/user/stored/card/delete";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, client.post(url, {
                            card_id: cardId,
                        })];
                case 2:
                    response = _a.sent();
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, refreshUserHistory()];
                case 3:
                    _a.sent();
                    return [2 /*return*/, true];
                case 4: return [3 /*break*/, 6];
                case 5:
                    _error_9 = _a.sent();
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/, false];
            }
        });
    }); }, [refreshUserHistory]);
    useEffect(function () {
        void checkForUserData();
    }, [checkForUserData]);
    var value = useMemo(function () { return ({
        isAuthenticated: isAuthenticated,
        hasResolvedAuthState: hasResolvedAuthState,
        setIsAuthenticated: setIsAuthenticated,
        handleLogin: handleLogin,
        createUser: createUser,
        createAddress: createAddress,
        updateAddress: updateAddress,
        deleteAddress: deleteAddress,
        deleteSavedCard: deleteSavedCard,
        updateUserProfile: updateUserProfile,
        deleteUserAccount: deleteUserAccount,
        checkForUserData: checkForUserData,
        checkForUserHistoryData: checkForUserHistoryData,
        refreshUserHistory: refreshUserHistory,
        user: user,
        history: history,
    }); }, [checkForUserData, checkForUserHistoryData, createAddress, createUser, deleteAddress, deleteSavedCard, deleteUserAccount, handleLogin, hasResolvedAuthState, history, isAuthenticated, refreshUserHistory, updateAddress, updateUserProfile, user]);
    return (React.createElement(AuthContext.Provider, { value: value }, children));
};
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};
